/**
 * Column definitions for EventStockReport tables
 */

import { formatCurrency } from '../../utils/formatting';

export const SALES_COLUMNS = [
  {
    field: 'title',
    headerName: 'Title',
    width: 200,
    filterable: false,
    renderCell: (p) => {
      if (p.row.id === 'total') return <b>{p.row.category ? p.row.category.toUpperCase() : ''}</b>;
    },
  },
  {
    field: 'category',
    headerName: 'Category',
    width: 100,
    filterable: false,
    renderCell: (p) => {
      if (p.row.id === 'total') return null;
      return p.row.category ? p.row.category.toUpperCase() : '';
    },
  },
  {
    field: 'price',
    headerName: 'Price',
    width: 100,
    filterable: false,
    renderCell: (p) => {
      if (p.row.id === 'total') return null;
      return formatCurrency(p.row.price);
    },
  },
  {
    field: 'original-stock',
    headerName: 'Total Stock',
    width: 100,
    filterable: false,
    valueGetter: (p) => {
      if (p.row.id === 'total') return null;
      return p.row.stock + p.row.sold;
    },
  },
  {
    field: 'stock',
    headerName: 'Remaining Stock',
    width: 100,
    filterable: false,
    renderCell: (p) => {
      if (p.row.id === 'total') return null;
      return p.row.remaining;
    },
  },
  {
    field: 'sold',
    headerName: 'Sold',
    width: 100,
    filterable: false,
    renderCell: (p) => {
      if (p.row.id === 'total') return <b>{p.row.sold}</b>;
      return p.row.sold;
    },
  },
  {
    field: 'totalSale',
    headerName: 'Total Sale',
    width: 100,
    filterable: false,
    renderCell: (p) => {
      if (p.row.id === 'total') return <b>{formatCurrency(p.row.totalSale)}</b>;
      return formatCurrency(p.row.totalSale);
    },
  },
];

export const REMAINING_PAYMENTS_COLUMNS = [
  {
    field: 'title',
    headerName: 'Title',
    width: 200,
    filterable: false,
    renderCell: (p) => {
      if (p.row.id === 'total') return <b>{p.row.category ? p.row.category.toUpperCase() : ''}</b>;
    },
  },
  {
    field: 'category',
    headerName: 'Category',
    width: 100,
    filterable: false,
    renderCell: (p) => {
      if (p.row.id === 'total') return null;
      return p.row.category ? p.row.category.toUpperCase() : '';
    },
  },
  {
    field: 'price',
    headerName: 'Price',
    width: 100,
    filterable: false,
    renderCell: (p) => {
      if (p.row.id === 'total') return null;
      return formatCurrency(p.row.price);
    },
  },
  {
    field: 'stock',
    headerName: 'Total Stock',
    width: 100,
    filterable: false,
    valueGetter: (p) => {
      if (p.row.id === 'total') return null;
      return p.row.stock + p.row.sold;
    },
  },
  {
    field: 'sold',
    headerName: 'Sold',
    width: 100,
    filterable: false,
    renderCell: (p) => {
      if (p.row.id === 'total') return <b>{p.row.sold}</b>;
      if (p.row.sold && p.row.sold != 0 && p.row.price && p.row.downPaymentAmount) {
        let remainingAmount = p.row.price - p.row.downPaymentAmount;
        return formatCurrency(remainingAmount);
      }
      return p.row.sold;
    },
  },
  {
    field: 'downPaymentAmount',
    headerName: 'Down Payment',
    width: 100,
    filterable: false,
    renderCell: (p) => {
      if (p.row.id === 'total') return null;
      return formatCurrency(p.row.downPaymentAmount);
    },
  },
];

export const COUPON_COLUMNS = [
  {
    field: 'code',
    headerName: 'Code',
    width: 150,
    filterable: false,
    renderCell: (p) => {
      if (p.row.id === 'total') return <b>{p.row.code}</b>;
      return p.row.code;
    },
  },
  {
    field: 'discount',
    headerName: 'Discount',
    width: 100,
    filterable: false,
    renderCell: (p) => {
      if (p.row.id === 'total') return null;
      return formatCurrency(p.row.discount);
    },
  },
  {
    field: 'stock',
    headerName: 'Stock',
    width: 100,
    filterable: false,
    renderCell: (p) => {
      if (p.row.id === 'total') return null;
      return p.row.stock;
    },
  },
  {
    field: 'used',
    headerName: 'Used',
    width: 100,
    filterable: false,
    renderCell: (p) => {
      if (p.row.id === 'total') return <b>{p.row.totalUsed}</b>;
      return p.row.used;
    },
  },
  {
    field: 'remaining',
    headerName: 'Remaining',
    width: 100,
    filterable: false,
    renderCell: (p) => {
      if (p.row.id === 'total') return null;
      let remaining = p.row.stock - (p.row.used ? p.row.used : 0);
      if (remaining < 0) remaining = 0;
      return remaining;
    },
  },
  {
    field: 'totalDiscount',
    headerName: 'Total Discount',
    width: 100,
    filterable: false,
    renderCell: (p) => {
      if (p.row.id === 'total')
        return p.row.totalDiscount ? <b>{formatCurrency(p.row.totalDiscount)}</b> : '-';
      let totalDisc = p.row.discount * (p.row.used ? p.row.used : 0);
      if (totalDisc == 0) return '-';
      else return formatCurrency(totalDisc);
    },
  },
];
